const CONST_SUB_GENRE_FILTER = {
  ALL: -1,
  ONLY: 1,
  NONE_ONLY: 0,
};

const CONST_SUB_DEL_GENRE_FILTER = {
  ALL: -1,
  HIDE_DEL: 1,
  SHOW_DEL: 0,
};

const BACKGROUND_TYPE = {
  COLOR: 0,
  IMG: 1,
};

const AREA_DISPLAY = {
  IN_GENRE: 0,
  TOP: 1,
  TOP_AND_IN_GENRE: 2,
};

const AREA_DISPLAY_OPTIONS = [
  { value: AREA_DISPLAY.IN_GENRE, label: 'ジャンル内' },
  { value: AREA_DISPLAY.TOP, label: 'TOP' },
  { value: AREA_DISPLAY.TOP_AND_IN_GENRE, label: 'TOP&ジャンル内' },
];

const objDefault = { CONST_SUB_GENRE_FILTER, BACKGROUND_TYPE, CONST_SUB_DEL_GENRE_FILTER, AREA_DISPLAY, AREA_DISPLAY_OPTIONS };

export default objDefault;
